import { render, staticRenderFns } from "./FormYaml.vue?vue&type=template&id=2284f3c7&"
import script from "./FormYaml.vue?vue&type=script&lang=js&"
export * from "./FormYaml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports